import React, { useState } from 'react'
import useIdentities from '../../hooks/api/useIdentities'

import AutocompleteFilter from './Autocomplete'

const Identity = ({
  selectedIdentities = [],
  setSelectedIdentities,
  multiple = true,
  ...props
}) => {
  const [queryString, setQueryString] = useState('')

  const { identities, ..._identites } = useIdentities(queryString, {
    is_claimed: true,
  })

  if (_identites.isLoading) return null

  const getCombinedName = (identity) => {
    return `${identity.firstName} ${identity.lastName}`
  }

  return (
    <>
      <AutocompleteFilter
        placeholder={'Account owners'}
        multiple={multiple}
        {...props}
        options={identities}
        value={multiple ? selectedIdentities : selectedIdentities[0] || null}
        setQueryString={setQueryString}
        getOptionLabel={getCombinedName}
        onChange={(_, value) => {
          setSelectedIdentities(value)
        }}
        isOptionEqualToValue={(a, b) => a && b && a.id === b.id}
      />
    </>
  )
}

export default Identity
